module.exports = __webpack_public_path__ + "static/0-174a84b4b0baa350660c3288c8137e01.png";